@if (data && data.length > 0 && !isPieChartLoder) {
  <div class="chart-container">
    @if (!isMaterialChart) {
      <p class="chart-title">Documents Categories</p>
    }
    <div [ngStyle]="{'width': chatWidth, 'height': chartHeight, 'display': 'block'}">
      <canvas [id]="chartId">Browser does not support canvas.</canvas>
    </div>
  </div>
}

@if (isPieChartLoder) {
  <div class="loader-container">
    <app-common-icon [loadingIcon]="true" class="text-danger"></app-common-icon>
  </div>
}

@if ((!data || data.length === 0) && !isPieChartLoder && showErrorMessage) {
  <div class="color-red error-message">
    <p>There are currently No files/documents</p>
  </div>
}